import type { EmployeeForBatchPayload } from '@app/reducers/orm/employee/employee.model';

export const FirstTouchOriginator = 'first-touch';

export interface TrackingMetaProps {
  entityCount: number;
}

// One row of the employees table, as the form in `EmployeesTableComponent` values it:
// an employee write payload plus the row-local controls. `Team` holds a single team id,
// unlike `EmployeeModel.Team`.
export interface EmployeesTableRowValue extends Omit<EmployeeForBatchPayload, 'team_id'> {
  Team: string;
  removable?: boolean;
  selected?: boolean;
}

export interface OnboardingStepConfig {
  originator?: string | typeof FirstTouchOriginator;
  skipFlow?: boolean;
}
